<template>
  <form @submit.prevent="submit">
    <h2 class="form__title">Регистрация <span class="form__title-part-separated">Шаг 6 из 6</span></h2>
    <h3 class="form__subtitle">Установка пароля</h3>
    <p class="form-row__description">Пароль должен состоять как&nbsp;минимум из&nbsp;8&nbsp;символов, содержать буквы латинского алфавита обоих регистров, цифры и&nbsp;специальные символы</p>

    <div class="form-row form-row_no-flex form-row_wrapper">
      <text-input
        label="Пароль"
        name="password"
        :type="passwordVisible ? 'text' : 'password'"
        v-model="$v.form.password.$model"
        :error="$v.form.password.$error"
      >
        <template #errors>
          <div class="text-input__error" v-if="$v.form.password.$error">
            <div v-if="!$v.form.password.required">Заполните поле</div>
          </div>
        </template>
      </text-input>
      <div
        class="password-visibility-button"
        :class="passwordVisible ? 'password-visibility-button_hide' : 'password-visibility-button_show'"
        @click="showHidePassword"
      ></div>
    </div>

    <div class="form-row form-row_no-flex">
      <text-input
        label="Подтверждение пароля"
        name="confirmPassword"
        :type="passwordVisible ? 'text' : 'password'"
        v-model="$v.form.confirmPassword.$model"
        :error="$v.form.confirmPassword.$error"
      >
        <template #errors>
          <div class="text-input__error" v-if="$v.form.confirmPassword.$error">
            <div v-if="!$v.form.confirmPassword.required">Заполните поле</div>
            <div v-if="$v.form.confirmPassword.required && !$v.form.confirmPassword.sameAsPassword">
              Пароли не совпадают
            </div>
          </div>
        </template>
      </text-input>
    </div>

    <smart-captcha ref="smartCaptcha" v-model="$v.form.captcha.$model">
      <template #errors>
        <div class="text-input__error">
          <div v-if="$v.form.captcha.$error">Необходимо пройти капчу</div>
        </div>
      </template>
    </smart-captcha>

    <div class="form-row form-row_mobile-wrap">
      <div class="form__nav">
        <!--
        <router-link v-if="!$store.state.currentUser" :to="{name: 'login'}" class="form__link">Войти</router-link>
        <router-link :to="{ name: 'feedback' }" class="form__link">Написать нам</router-link>
        -->
        <delete-questionnaire-btn />
      </div>
      <button class="form__submit button button__lg button__blue" type="submit">Сохранить и&nbsp;продолжить</button>
    </div>
  </form>
</template>

<script>
  import {required, sameAs} from "vuelidate/lib/validators";
  import TextInput from './TextInput';
  import api from '../services/api';
  import SmartCaptcha from "./SmartCaptcha.vue";
  import SmartCaptchaMixin from "../mixins/smartCaptchaMixin";

  export default {
  name: "SignUpStepPassword",
  mixins: [SmartCaptchaMixin],
  components: {
    SmartCaptcha,
    TextInput,
  },
  data() {
    return {
      form: {
        password: '',
        confirmPassword: '',
        captcha: ''
      },
      passwordVisible: false
    };
  },
  validations: {
    form: {
      password: {required},
      captcha: {required},
      confirmPassword: {
        required,
        sameAsPassword: sameAs('password'),
      },
    },
  },
  methods: {
    async submit() {
      await this.refreshCaptcha();

      this.$v.form.$touch();

      if (!this.$v.form.$pending && !this.$v.form.$invalid) {
        this.$store.dispatch('showLoader');

        try {
          const result = await api.registerStepPassword(this.form);

          if (result) {
            this.$emit('complete');
            this.$store.dispatch('hideErrorsBag');
          }
        } catch (e) {
          this.$store.dispatch('setErrors', e);

        } finally {
          this.$store.dispatch('hideLoader');
        }
      }
    },
    showHidePassword() {
      this.passwordVisible = !this.passwordVisible;
    },
  },
}
</script>
<style lang="scss">
@import "../scss/base/_settings.scss";
.password-visibility-button {
  position: absolute;
  right: 16px;
  top: 18px;
  width: 18px;
  height: 18px;
  background-repeat: no-repeat;
  cursor: pointer;

  &_hide {
    background-image: url('data:image/svg+xml,<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.8"><path d="M17.1343 8.51246C16.4704 7.11163 15.6784 5.96916 14.7625 5.08611L13.799 6.04752C14.5846 6.79716 15.2676 7.77869 15.8584 8.99952C14.285 12.2554 12.0519 13.8023 9.00041 13.8023C8.13853 13.8113 7.28183 13.6679 6.46983 13.3788L5.42688 14.4218C6.49841 14.9162 7.68959 15.1629 9.00041 15.1629C12.6343 15.1629 15.3459 13.2708 17.1343 9.48552C17.2064 9.33327 17.2438 9.16691 17.2438 8.99846C17.2438 8.83 17.2064 8.66365 17.1343 8.5114V8.51246ZM15.9325 2.44963L15.1268 1.64281C15.1128 1.62866 15.0961 1.61743 15.0778 1.60976C15.0594 1.60209 15.0397 1.59814 15.0198 1.59814C14.9999 1.59814 14.9802 1.60209 14.9619 1.60976C14.9435 1.61743 14.9269 1.62866 14.9129 1.64281L12.8439 3.70963C11.7036 3.12728 10.4224 2.83611 9.00041 2.83611C5.36547 2.83611 2.65383 4.72822 0.865473 8.51352C0.793535 8.66581 0.756226 8.83215 0.756226 9.00058C0.756226 9.169 0.793535 9.33534 0.865473 9.48763C1.58018 10.9922 2.43994 12.1982 3.44583 13.1067L1.44465 15.1079C1.41665 15.1362 1.40095 15.1744 1.40095 15.2143C1.40095 15.2541 1.41665 15.2924 1.44465 15.3207L2.25253 16.1275C2.28092 16.1558 2.31938 16.1717 2.35947 16.1717C2.39957 16.1717 2.43803 16.1558 2.46641 16.1275L15.9325 2.66352C15.9609 2.63513 15.9768 2.59667 15.9768 2.55658C15.9768 2.51648 15.9609 2.47802 15.9325 2.44963ZM2.14241 8.99952C3.71794 5.74363 5.951 4.19775 9.00041 4.19775C10.0317 4.19775 10.9698 4.37458 11.8201 4.73458L10.4912 6.0634C9.86176 5.72745 9.14097 5.60272 8.4352 5.7076C7.72943 5.81248 7.07606 6.14142 6.57147 6.64589C6.06688 7.15036 5.73779 7.80366 5.63274 8.5094C5.5277 9.21514 5.65226 9.93596 5.98806 10.5655L4.41041 12.1432C3.53794 11.3723 2.78512 10.3283 2.14241 8.99952ZM6.80759 8.99952C6.808 8.66622 6.88699 8.33771 7.03817 8.04066C7.18934 7.74361 7.40843 7.4864 7.67764 7.2899C7.94686 7.09341 8.25862 6.96316 8.58762 6.90974C8.91661 6.85632 9.25356 6.88124 9.57112 6.98246L6.90818 9.64752C6.84142 9.43873 6.80749 9.22084 6.80759 9.00163V8.99952Z" fill="%237A8BB2"/><path d="M8.92515 11.1204C8.8595 11.1204 8.79491 11.1173 8.73138 11.112L7.73291 12.1104C8.33351 12.3399 8.98768 12.3905 9.61645 12.2563C10.2452 12.1221 10.8217 11.8088 11.2763 11.3541C11.7308 10.8994 12.044 10.3229 12.1781 9.69405C12.3122 9.06525 12.2613 8.41109 12.0317 7.81055L11.0343 8.80902C11.0752 9.259 10.9714 9.71028 10.7379 10.0971C10.5044 10.4839 10.1534 10.7861 9.7362 10.9595C9.47891 11.0654 9.20362 11.1204 8.92515 11.1204Z" fill="%237A8BB2"/></g></svg>');
  }

  &_show {
    background: url('data:image/svg+xml,<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.1357 8.51252C15.3432 4.73636 12.6333 2.83618 9.00001 2.83618C5.36545 2.83618 2.658 4.73636 0.864321 8.51373C0.792338 8.66604 0.755005 8.83242 0.755005 9.00088C0.755005 9.16935 0.792338 9.33572 0.864321 9.48803C2.65679 13.2642 5.36666 15.1644 9.00001 15.1644C12.6346 15.1644 15.342 13.2642 17.1357 9.48682C17.2077 9.33451 17.245 9.16814 17.245 8.99967C17.245 8.83121 17.2077 8.66483 17.1357 8.51252ZM9.00001 13.804C5.95003 13.804 3.7158 12.2572 2.14119 9.00028C3.7158 5.74455 5.95003 4.19657 9.00001 4.19657C12.05 4.19657 14.2842 5.74455 15.8588 9.00028C14.2854 12.256 12.0524 13.804 9.00001 13.804Z" fill="%237A8BB2" fill-opacity="0.8"/><path d="M8.92478 5.67212C8.04205 5.67212 7.19547 6.02278 6.57128 6.64697C5.9471 7.27115 5.59644 8.11773 5.59644 9.00046C5.59644 9.8832 5.9471 10.7298 6.57128 11.354C7.19547 11.9781 8.04205 12.3288 8.92478 12.3288C9.80751 12.3288 10.6541 11.9781 11.2783 11.354C11.9025 10.7298 12.2531 9.8832 12.2531 9.00046C12.2531 8.11773 11.9025 7.27115 11.2783 6.64697C10.6541 6.02278 9.80751 5.67212 8.92478 5.67212ZM8.92478 11.1185C8.36304 11.1185 7.82431 10.8954 7.4271 10.4981C7.02989 10.1009 6.80674 9.5622 6.80674 9.00046C6.80674 8.43873 7.02989 7.89999 7.4271 7.50279C7.82431 7.10558 8.36304 6.88243 8.92478 6.88243C9.48652 6.88243 10.0252 7.10558 10.4225 7.50279C10.8197 7.89999 11.0428 8.43873 11.0428 9.00046C11.0428 9.5622 10.8197 10.1009 10.4225 10.4981C10.0252 10.8954 9.48652 11.1185 8.92478 11.1185Z" fill="%237A8BB2" fill-opacity="0.8"/></svg>');
  }
}
</style>
